import React, { useState, useMemo, useEffect } from "react";
import { Container, Button, Box, Typography, TextField, Checkbox, Grid, CircularProgress } from "@material-ui/core";
import gql from 'graphql-tag';
import { useSelector } from "react-redux";
import { useLazyQuery } from '@apollo/client';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Close from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton'; 
import { useMutation, useQuery } from '@apollo/client';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import * as lodash from 'lodash';
import Axios from 'axios';
import { getBaseURL } from "../../baseURL";

export const ManageCompanies = () => {

    const ADD_New_COMPANY_Request = gql`
    mutation AddNewCompanyRequest($companyName: String!,$reason: String!) {
        addNewCompanyRequest(requestedCompany: $companyName,reason:$reason) {
            id
        }
    }
`;

    const GET_COMPANIES = gql`
        query GetCompanies {
            company {
                name
                id
                state
            }
        }
    `;
    const GET_Requested_COMPANIES = gql`
    query GetRequestedCompanies {
        requestedCompany {
            id
            requestedCompany            
            reason
            requestedBy
            requestedDate
        }
    }
`;
    const GET_COMPANY_USERS = gql`
        query GetCompanyUsers($companyId: Int!){
            companyUsers(companyId: $companyId) {
                
                email
            }
        }
        `;
    const UPDATE_COMPANY = gql`
        mutation UpdateCompany($companyId: Int!, $state: Boolean) {
            updateCompany(companyId: $companyId, state: $state) {
                id
            }
        }
    `;
    const UPDATE_COMPANY_NAME = gql`
        mutation UpdateCompanyName($companyId: Int!, $companyName: String, $oldName: String) {
            updateCompanyName(companyId: $companyId, companyName: $companyName,oldName: $oldName) {
                id
            }
        }
    `;

    const DELETE_COMPANY = gql`
    mutation DeleteCompany($companyId: Int!) {
        deleteCompany(companyId: $companyId) {
           id
        }
    }
`;

    const currentUser = useSelector(state => state.auth);
    const [addCompanyOpen, setAddCompanyOpen] = useState(false);
    const [renameCompanyOpen, setRenameCompanyOpen] = useState(false);
    const [isRename, setIsRename] = useState(false);
    const [loading, setLoading] = useState(false);
    const [addCompanyMutation, { error: addCompanyErrors }] = useMutation(ADD_New_COMPANY_Request);
    const [companyId, setCompanyId] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [reason, setReason] = useState("");
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const { error, refetch, data } = useQuery(GET_COMPANIES);
    const [RequestedNewCompanies, setRequestedNewCompanies] = useState([]);
    const { requestedNewCompanies } = useQuery(GET_Requested_COMPANIES, {
        onCompleted: data => {

            setRequestedNewCompanies(data.requestedcompany)
        }
    });
    const [addCompanyError, setAddCompanyError] = useState("");
    const [renameCompanyError, setRenameCompanyError] = useState("");
    const [addReasonError, setAddReasonError] = useState("");
    const [updateCompanyMutation] = useMutation(UPDATE_COMPANY);
    const [updateCompanyNameMutation] = useMutation(UPDATE_COMPANY_NAME);
    const [deleteCompanyMutation] = useMutation(DELETE_COMPANY);
    const [companies, setCompanies] = useState([]);
    const config = {
        headers: { 'Authorization': "Bearer " + currentUser.jwtIdToken.idToken },
        timeout: 24000000
    };
    //To View Company Users 
    const [openView, setOpenView] = useState(false);
    const [getCompanyUsers] = useLazyQuery(GET_COMPANY_USERS);
    const [internalUsers, setInternalUsers] = useState([]);
    const [externalUsers, setExternalUsers] = useState([]);

    const handleViewOpen = async (value) => {
        setOpenView(true);
        setCompanyId(value.id);
        console.log("companyid " + value.id);
        setEditingItemName(value.name);

        const { data } = await getCompanyUsers({
            variables: { companyId: value.id }
        });
        console.log({ data });

        if (data?.companyUsers) {
            const users = data.companyUsers;

            setInternalUsers(users.filter(u => u.email.includes('.komatsu')));
            setExternalUsers(users.filter(u => !u.email.includes('.komatsu')));
        }
    };

    // State to track the Company Name being edited
    const [editingItemName, setEditingItemName] = useState(null);
    const handleRenameClick = (value) => {
        setRenameCompanyOpen(true);
        setCompanyId(value.id);

        setEditingItemName(value.name);
    };


    // Function to handle renaming
    const handleRename = async (event) => {
        event.preventDefault();
        if (companyName === "") {
            setRenameCompanyError("Company Name is mandatory");
            return;
        }

        const companyExists = companies.some(company => company.name.toLowerCase() === companyName.toLowerCase());
        if (companyExists) {
            setRenameCompanyError("Company Already Exists");
            return;
        }

        setLoading(true);
        try {
            // Perform the GraphQL mutation
            await updateCompanyNameMutation({ variables: { companyId: companyId, companyName: companyName, oldName: editingItemName } }).then(data => {
                refetch(GET_COMPANIES);
            });
            // Reset form values and close dialog after successful mutation
            setCompanyName("");
            setRenameCompanyOpen(false);
            setIsRename(true);
            setSnackBarOpen(true);

        }
        catch (error) {
            console.error("An error occurred:", error);
            setRenameCompanyError("An error occurred");
        }
        finally {
            setLoading(false);
            
        }
        

    };
    //Grouping companies based on alphabetical header
    const groupedData = useMemo(() => {
        // Group by first letter 
        const grouped = Object.groupBy(companies, ({ name }) => name.charAt(0).toUpperCase());
        // Sort letters
        const sortedLetters = Object.keys(grouped).sort();
        return { grouped, sortedLetters };
    }, [companies]);

    const [expandedLetters, setExpandedLetters] = useState({});

    const toggleGroup = (letter) => {
        setExpandedLetters(prev => ({
            ...prev,
            [letter]: !prev[letter]
        }));
    };
    const handleDownloadClick = () => {
        if (companyName === "") {
            setAddCompanyError("Company Name is mandatory");
            return;
        }
        if (reason === "") {
            setAddReasonError("Reason is mandatory");
            return;
        }
        const companyExists = companies.some(company => company.name.toLowerCase() === companyName.toLowerCase());
        if (companyExists) {
            setAddCompanyError("Company Already Exists");
            return;
        }
        const formData = {
            CompanyName: companyName,
            Reason: reason,
        }
        Axios.post(`${getBaseURL()}files/addNewCompany`, formData, config)
            .then((response) => {
                if (response.status === 200) {
                    setCompanyName("");
                    setReason("");
                    setAddCompanyOpen(false);
                    setSnackBarOpen(true);

                } else {
                    console.error("An error occurred:", error);
                    setAddCompanyError("An error occurred");
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error);
                setAddCompanyError("An error occurred");
            })
        setAddCompanyOpen(false);
        setSnackBarOpen(true);
    };

    const onAddCompany = async (event) => {
        event.preventDefault();
        if (companyName === "") {
            setAddCompanyError("Company Name is mandatory");
            return;
        }

        if (reason === "") {
            setAddReasonError("Reason is mandatory");
            return;
        }

        // Check if the company already exists
        const companyExists = companies.some(company => company.name.toLowerCase() === companyName.toLowerCase());
        if (companyExists) {
            setAddCompanyError("Company Already Exists");
            return;
        }

        setLoading(true);
        try {
            // Perform the GraphQL mutation
            await addCompanyMutation({ variables: { companyName: companyName, reason: reason } });
            // Reset form values and close dialog after successful mutation
            setCompanyName("");
            setReason("");
            setAddCompanyOpen(false);
            setSnackBarOpen(true);
        } catch (error) {
            console.error("An error occurred:", error);
            setAddCompanyError("An error occurred");
        } finally {
            setLoading(false);
        }
    }
    // const onAddCompany = async (event) => {
    //     if (companyName !== "" && reason !== "") {
    //         for (let i = 0; i < companies.length; i++) {
    //             if (companies[i].name === companyName.toLowerCase()) {
    //                 setAddCompanyError("Company Already Exists")
    //                 break;
    //             }
    //         }
    //         // if (companies.find(e => e.name.toLowerCase() === companyName.toLowerCase()) || RequestedNewCompanies.find(e => e.requestedCompany.toLowerCase() === companyName.toLowerCase())) {
    //         //     setAddCompanyError("Company Already Exists")
    //         // }
    //         //else {
    //         event.preventDefault();
    //         setLoading(true);
    //         addCompanyMutation({ variables: { companyName: companyName, reason: reason } })
    //             .then(r => {
    //                 setTimeout(() => {
    //                     setAddCompanyOpen(false);
    //                     setSnackBarOpen(true);
    //                     setLoading(false);
    //                 }, 1000);
    //             })
    //             .catch(e => {
    //                 setAddCompanyError("An error occured");
    //                 setLoading(false);
    //             })
    //         //}
    //     }
    //     else if (companyName === "") {
    //         setAddCompanyError("Company Name is mandatory")
    //         setLoading(false);
    //     }
    //     else if (reason === "") {
    //         setAddReasonError("Reason is mandatory")
    //         setLoading(false);
    //     }
    // }

    useEffect(() => {
        if (data && data.company) {
            setCompanies(data.company);
        }
    }, [data])
    useEffect(() => {
        if (data && data.company) {
            setCompanies(data.company);
        }
    }, [data])
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBarOpen(false);
        setIsRename(false);
    }

    const Alert = (props) => {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const onCompanyCheckChange = (companyId, checked) => {
        var companiesCopy = lodash.cloneDeep(companies);
        companiesCopy.find(x => x.id === companyId).state = checked;
        setCompanies(companiesCopy);

        updateCompanyMutation({ variables: { companyId: companyId, state: checked } });
    }
    const onRequestAction = (id) => {
        deleteCompanyMutation({ variables: { companyId: id } })
            .then(data => {
                refetch(GET_COMPANIES);
            })
            .catch(e => {
                var companiesCopy = [...companies];
                companiesCopy.find(x => x.id === id).error = true;
                setCompanies(companiesCopy);
            });
    }
    return (
        <Container maxWidth={'xl'} disableGutters={true}>
            <Grid container alignItems="flex-start" justify="flex-end" direction="row">
                <Typography variant="h4" style={{ flex: 1 }}>Manage Companies</Typography>
                <Button variant="contained" color="primary" onClick={() => setAddCompanyOpen(true)}>Add Company</Button>
                {
                    addCompanyOpen && (
                        <Dialog onClose={() => setAddCompanyOpen(false)} open={addCompanyOpen} fullWidth={true} maxWidth={'sm'}>
                            <DialogTitle>Add Company</DialogTitle>
                            <DialogContent>
                                <TextField
                                    color="primary"
                                    variant="outlined"
                                    label="Company Name"
                                    fullWidth
                                    onChange={(e) => { setCompanyName(e.target.value); setAddCompanyError("") }}
                                    error={addCompanyError.length > 0}
                                    helperText={addCompanyError}
                                />

                            </DialogContent>
                            <DialogContent>
                                <TextField
                                    color="primary"
                                    variant="outlined"
                                    label="Reason"
                                    fullWidth
                                    onChange={(e) => { setReason(e.target.value); setAddReasonError("") }}
                                    error={addReasonError.length > 0}
                                    helperText={addReasonError}
                                />

                            </DialogContent>
                            <DialogActions>
                                <Button
                                    label="Submit Request"
                                    color="primary"
                                    onClick={handleDownloadClick}
                                    disabled={loading}
                                >{loading ? <CircularProgress style={{ margin: 0, padding: 0, marginLeft: '40%', marginBottom: '45%' }} /> : 'Submit Request'}</Button>
                                <Button
                                    label="Cancel"
                                    color="primary"
                                    onClick={() => setAddCompanyOpen(false)}
                                >Cancel</Button>
                            </DialogActions>
                        </Dialog>
                    )
                }
            </Grid>

            {!loading && companies &&
                <TableContainer component={Paper} style={{ marginTop: '10px' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Enabled</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {groupedData.sortedLetters.map((letter) => (
                                <React.Fragment key={letter}>
                                    {/* Section Header Row */}
                                    <TableRow
                                        onClick={() => toggleGroup(letter)}
                                        style={{ cursor: 'pointer', backgroundColor: '#f5f5f5' }}
                                    >
                                        <TableCell colSpan={3} style={{ fontWeight: 'bold' }}>
                                            {expandedLetters[letter] ? '▼' : '▶'} {letter}
                                        </TableCell>
                                    </TableRow>
                                    {expandedLetters[letter] && groupedData.grouped[letter].map((item) => (
                                        <TableRow key={item.id}>
                                            <TableCell style={{ paddingLeft: '20px' }}>{item.name}</TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    checked={item.state}
                                                    color="primary"
                                                    onChange={() => onCompanyCheckChange(item.id, !item.state)}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <Box sx={{ display: 'flex', gap: 9 }}>

                                                    <Button variant="contained" color="primary" onClick={() => handleRenameClick(item)}>Rename</Button>
                                                    {

                                                        renameCompanyOpen && (
                                                            <Dialog onClose={() => setRenameCompanyOpen(false)} open={renameCompanyOpen} fullWidth={true} maxWidth={'sm'}>
                                                                <DialogTitle>Rename Company</DialogTitle>
                                                                <DialogContent>
                                                                    <label>Current Company Name : {editingItemName} </label>
                                                                    <TextField
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        label="Rename Company Name"
                                                                        fullWidth
                                                                        onChange={(e) => { setCompanyName(e.target.value); setRenameCompanyError("") }}
                                                                        error={renameCompanyError.length > 0}
                                                                        helperText={renameCompanyError}
                                                                    />

                                                                </DialogContent>

                                                                <DialogActions>
                                                                    <Button
                                                                        label="Submit Request"
                                                                        color="primary"
                                                                        onClick={handleRename}
                                                                        disabled={loading}
                                                                    >{loading ? <CircularProgress style={{ margin: 0, padding: 0, marginLeft: '40%', marginBottom: '45%' }} /> : 'Submit Request'}</Button>
                                                                    <Button
                                                                        label="Cancel"
                                                                        color="primary"
                                                                        onClick={() => setRenameCompanyOpen(false)}
                                                                    >Cancel</Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                        )
                                                    }
                                                   
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => handleViewOpen(item)}
                                                    >View Users</Button>
                                                    <Dialog open={openView} onClose={() => setOpenView(false)} fullWidth>
                                                       < DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        Company Name : {editingItemName}

                                                        <IconButton
                                                            aria-label="close"
                                                            onClick={() => setOpenView(false)}
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '8px',
                                                                    top: '8px',
                                                                    color: '#9e9e9e', // Material Grey
                                                                }}
                                                        >
                                                            <Close />
                                                        </IconButton>
                                                    </DialogTitle>
                                                        <DialogContent dividers>
                                                            <h4>Internal Users </h4>
                                                            {internalUsers.length > 0 ? (
                                                                <ul>{internalUsers.map(u => <li key={u.id}>{u.email}</li>)}</ul>
                                                            ) : <p>No internal users found.</p>}

                                                            <hr />

                                                            <h4>External Users</h4>
                                                            {externalUsers.length > 0 ? (
                                                                <ul>{externalUsers.map(u => <li key={u.id}>{u.email}</li>)}</ul>
                                                            ) : <p>No external users found.</p>}
                                                        </DialogContent>
                                                    </Dialog>
                                                    {item.error ?
                                                        <Typography variant="subtitle1">AN ERROR OCCURED</Typography>
                                                        :
                                                        item.deleted ?
                                                            <Typography variant="subtitle1">DELETED</Typography>
                                                            :
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={() => onRequestAction(item.id)}
                                                            >Delete</Button>}

                                                </Box>
                                            </TableCell>
                                        </TableRow>

                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            
            <Snackbar
                open={snackBarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                {isRename ? (<Alert onClose={handleSnackbarClose} severity="success">
                    Rename Successful!
                </Alert>) :

                    (<Alert onClose={handleSnackbarClose} severity="success">
                        Request to add {companyName} submitted successfully!
                    </Alert>)}
               
        </Snackbar>
            
        </Container>
    );
}